import { z } from 'zod';
export * from './email.js';
export * from './password.js';
export * from './auth.js';
// Standard response envelopes
export function successResponse(dataSchema) {
    return z.object({
        success: z.literal(true),
        data: dataSchema,
        requestId: z.string().uuid(),
    });
}
export const errorResponse = z.object({
    success: z.literal(false),
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
    requestId: z.string().uuid(),
});
//# sourceMappingURL=index.js.map